import {FETCH_ENABLE_MULTIPLY, FETCH_SETTINGS, LIST_ENABLE_MULTIPLY, LIST_SETTINGS} from "./types";

const init = {
    isLoading: true,
    list: [],
    enableMultiply: {},
    page: 1,
    totals: 0,
    size: 10
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_SETTINGS:
            return {
                ...state,
                isLoading: true
            };
        case LIST_SETTINGS:
            return {
                ...state,
                isLoading: false,
                list: payload.data,
                ...payload.paging
            };
        case FETCH_ENABLE_MULTIPLY:
            return {
                ...state,
                isLoading: true
            };
        case LIST_ENABLE_MULTIPLY:
            return {
                ...state,
                isLoading: false,
                enableMultiply: payload.data
            };
        default:
            return state;
    }
}